import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

export const apiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [
    apiDocsPlugin.getExtension('page:api-docs').override({
      params: {
        title: 'Volkswagen API Explorer',
        loader: async () => {
          const { CustomApiExplorerPage } = await import('../components/api-docs/ApiExplorerPage');
          return <CustomApiExplorerPage />;
        },
      },
    }),
  ],
});
